<div>
    <div class="dialog-header-container">
        <h2 mat-dialog-title class="pd-t-5px">Edit Attendee</h2>
        <div>            
            <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <div mat-dialog-content id="editAttendeeDialog" class="dialog-with-actions">
        <mat-form-field class="para-container input-field-formatting body-font-size">
            <mat-label class="body-font-size">Attendee Name</mat-label>
            <input class="body-font-size" type="text"  [attr.name] = "attendeeName" id="editAttendeeNameId" matInput placeholder="Attendee Name" [(ngModel)]="attendeeName" name="name" autocomplete="off"  (selectionChange)="loadEditedUserInfo()">
        </mat-form-field>
        <form [formGroup]="attendeeForm">
              <mat-form-field class="para-container input-field-formatting body-font-size">
                <mat-label class="body-font-size">Attendee Email</mat-label>
                <input class="body-font-size" type="text" formControlName="mail" matInput placeholder="Attendee Email" [attr.email] = "attendeeEmail" [(ngModel)]="attendeeEmail" (blur)="checkEmailExists()" name="name" autocomplete="off" >
              <mat-error *ngIf="attendeeForm.get('mail')?.hasError('email')">
                Invalid email address
              </mat-error>
            </mat-form-field>
          </form>
        <mat-form-field class="para-container input-field-formatting">
            <mat-label class="body-font-size">Role</mat-label>
            <mat-select disableOptionCentering panelClass="common-drop-down-class" class="body-font-size" [(value)]="attRole" placeholder="Role" (click)="roleValue(attRole)"  (selectionChange)="onAttRoleChange($event)">

                <mat-option class="body-font-size" *ngFor="let role of roleList" code="role.code" [disabled] = "disableRoleList" [value]="role.code">
                    {{role.description}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <label class="mat-checkbox">
            <input [disabled]="attUserId==userId" type="checkbox" [(ngModel)]="isChecked" (click)="onCheckboxChange()" id="presenceCheckbox">
            <span class="mat-checkbox-box"></span>
            <span class="lettr-space pl-2" [ngStyle]="{'padding-left':'4px'}">Present</span>
          </label>
        <input class="body-font-size" type="hidden" id="attUserId" [attr.userId] = "attUserId" [(ngModel)]="attUserId" />
        <input class="body-font-size" type="hidden" id="attendeeRole" [(ngModel)]="attendeeRole" />
        <input class="body-font-size" type="hidden" id="attendeeRoleCode" [(ngModel)]="attendeeRoleCode" />
        <input class="body-font-size" type="hidden" id="fkCodelstAttendeeRole" [(ngModel)]="fkCodelstAttendeeRole" />
        <input class="body-font-size" type="hidden" id="attendeeId" [(ngModel)]="attendeeId" />
    </div>

    <div class="d-flex justify-content-end" mat-dialog-actions>
        <span><button class="button-container primary" type="button" mat-flat-button color="primary"
                (click)="saveEditedAttendee($event)">Save</button></span>&nbsp;&nbsp;
        <span>
            <!-- <button
              type="button"
              mat-flat-button
              color="primary"
              [mat-dialog-close]="true"
            >
              Clear
            </button> -->
            <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" (click)="closeDialog()">
                Cancel
            </button>
        </span>
    </div>
</div>